import CrateForm from "../../forms/CrateForm";
import IconButton from "../../components/IconButton";
import RequestContainer from "../../components/RequestContainer";
import ViewContents from "../../components/ViewContents";
import ViewHeader from "../../components/ViewHeader";
import toast from "../../lib/toast";
import { Save } from "react-feather";
import { getCrate, updateCrate } from "../../clients/collection";
import { useParams, useHistory } from "react-router-dom";
import { useRequest, useAutoRequest } from "../../hooks/useRequest";

function EditCrate() {
  let { crate_id: id } = useParams();
  const updateCrateRequest = useRequest(updateCrate);
  const getCrateRequest = useAutoRequest(getCrate, id);
  let history = useHistory();

  const crate = getCrateRequest.response.data || {};
  const loading = getCrateRequest.loading || updateCrateRequest.loading;
  const error = getCrateRequest.error || updateCrateRequest.error;

  return (
    <CrateForm
      initialValues={getCrateRequest.response.data}
      enableReinitialize={true}
      onSubmit={(values) => {
        updateCrateRequest.execute({ id, data: values }, () => {
          history.goBack();
          toast(`The crate was saved`);
        });
      }}
    >
      {(fields) => (
        <>
          <ViewHeader
            breadcrumbs={[`${crate.name || ""}`]}
            actions={
              <IconButton
                type="submit"
                disabled={loading}
                icon={Save}
                className="btn btn-success"
              >
                Save
              </IconButton>
            }
          />
          <ViewContents>
            <RequestContainer loading={loading} error={error}>
              {fields}
            </RequestContainer>
          </ViewContents>
        </>
      )}
    </CrateForm>
  );
}

export default EditCrate;
